import {
    ExamplePagesOccupationBeats,
    EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
    SEO_RESULTS_PER_PAGE,
    SEO_URL_EXAMPLE_PAGES_SUFIX
} from "@authory-packages/seo-static-data";
import { PanelLink } from "../../../../components/MarketingCarouselCategories";
import { ExamplesPageLayout } from "../../../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../../../shared-logic/routes";

const ExampleJobPage = ({ panelLinks, pageNumber }: { panelLinks: PanelLink[]; pageNumber: number }) => (
    <ExamplesPageLayout
        title={<>Example Portfolios by professional categories</>}
        description={<>Check out hundreds of stunning portfolios, sorted by different professional categories for easy browsing.</>}
        panelLinks={panelLinks}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Example Portfolios by professional categorie"}
        ogDescription={"Check out hundreds of stunning portfolios, sorted by different professional categories for easy browsing."}
        embedConf={[]}
        pagination={{
            page: pageNumber,
            limit: SEO_RESULTS_PER_PAGE,
            pages: EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
            total: ExamplePagesOccupationBeats.length,
            prev: pageNumber === 1 ? null : pageNumber - 1,
            next: pageNumber + 1 < EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES ? pageNumber + 1 : null
        }}
        paginationURL={APPLICATION_ROUTES.EXAMPLES_PROFESSION_CATEGORIES}
        faq={[]}
    />
);

export async function getStaticPaths() {
    let paths: { params: { page: string } }[] = [];

    if (process.env.EXAMPLES_PAGES_PIPELINE) {
        for (let pageIndex = 1; pageIndex <= EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES; pageIndex++) {
            paths.push({ params: { page: pageIndex.toString() } });
        }
    }

    return { paths, fallback: false };
}

export async function getStaticProps(ctx: any) {
    const page = ctx.params.page as string;
    const pageNumber = parseInt(page);
    const begin = (pageNumber - 1) * SEO_RESULTS_PER_PAGE;
    const end = Math.min(pageNumber * SEO_RESULTS_PER_PAGE, ExamplePagesOccupationBeats.length);

    const panelLinks = ExamplePagesOccupationBeats.slice(begin, end).map((occ) => ({
        url: `${APPLICATION_ROUTES.EXAMPLES}/${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}`,
        label: occ.occupation
    }));

    return {
        props: {
            panelLinks,
            pageNumber
        }
    };
}

export default ExampleJobPage;
